import { render, staticRenderFns } from "./chatRecord.vue?vue&type=template&id=4b5d8788&scoped=true&"
import script from "./chatRecord.vue?vue&type=script&lang=js&"
export * from "./chatRecord.vue?vue&type=script&lang=js&"
import style0 from "./chatRecord.vue?vue&type=style&index=0&id=4b5d8788&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5d8788",
  null
  
)

export default component.exports